import type { ReactNode } from 'react'

import styles from './app-skeleton.module.css'

const AppSkeleton = () => <div className={styles.skeletonInput} />

const FormItem = () => (
  <div className={styles.formItem}>
    <span className={styles.skeletonText} />
    <div className={styles.skeletonInput} />
  </div>
)

const Container = ({ children }: { children: ReactNode }) => (
  <div className={styles.container}>{children}</div>
)

AppSkeleton.FormItem = FormItem
AppSkeleton.Container = Container
export { AppSkeleton }
